import classNames from 'classnames';
import React from 'react';
var classPrefix = "adm-dropdown-item";

var Item = function Item(props) {
  var _classNames;

  var cls = classNames(classPrefix, props.className, (_classNames = {}, _classNames[classPrefix + "-active"] = props.active, _classNames[classPrefix + "-highlight"] = props.highlight, _classNames));
  return /*#__PURE__*/React.createElement("div", {
    className: cls,
    style: props.style,
    onClick: props.onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-title"
  }, /*#__PURE__*/React.createElement("span", null, props.title)));
};

export default Item;